/** True for iPhone/iPad/iPod user-agent strings (and not Windows Phone "MSStream"). */
export function isIOS(ua: string): boolean {
  return /iPad|iPhone|iPod/.test(ua) && !/MSStream/.test(ua);
}

type RtcGlobals = {
  RTCPeerConnection?: unknown;
  mozRTCPeerConnection?: unknown;
  webkitRTCPeerConnection?: unknown;
};

/** True when the environment exposes any (possibly vendor-prefixed) RTCPeerConnection. */
export function isRtcSupported(g: RtcGlobals): boolean {
  return !!(g.RTCPeerConnection || g.mozRTCPeerConnection || g.webkitRTCPeerConnection);
}
